import React from "react";
import loading from "../../img/loading.gif";
import createMemo from "@src/static/hooks/createMemo";
import "./index.less";

const LoadingComponent = (props: any) => {
  return props.loading === false ? (
    <React.Fragment>{props.children}</React.Fragment>
  ) : (
    <div className="loadingPage">
      <img src={loading} alt="loading..."></img>
    </div>
  );
};

export default createMemo(LoadingComponent);
